import React from 'react'

const Logo = () => {
  return (
    <div className='logo'>
      <img src="/src/pictures/logo/logo.png" alt="" />
    </div>
  )
}

export default Logo